import { render, staticRenderFns } from "./Auto_together.vue?vue&type=template&id=57afa3c8&scoped=true"
import script from "./Auto_together.vue?vue&type=script&lang=js"
export * from "./Auto_together.vue?vue&type=script&lang=js"
import style0 from "./Auto_together.vue?vue&type=style&index=0&id=57afa3c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57afa3c8",
  null
  
)

export default component.exports